import { render, staticRenderFns } from "./SchemeSelector.vue?vue&type=template&id=2067f4dc&scoped=true&"
import script from "./SchemeSelector.vue?vue&type=script&lang=ts&"
export * from "./SchemeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SchemeSelector.vue?vue&type=style&index=0&id=2067f4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067f4dc",
  null
  
)

export default component.exports